import { render, staticRenderFns } from "./ModalBienBanHC.vue?vue&type=template&id=be3f8b6a&scoped=true"
import script from "./ModalBienBanHC.vue?vue&type=script&lang=js"
export * from "./ModalBienBanHC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3f8b6a",
  null
  
)

export default component.exports